export default __webpack_public_path__ + "static/Graphik-Medium-Web-4fd4559d64c834f4d083901680760a08.ttf";